import {roadmap} from "../../data/data";
import RoadmapCard from "./RoadmapCard";
import "./RoadmapPage.css";
import { useNavigate } from "react-router-dom";

const RoadmapPage = () => {
  const navigate = useNavigate();

    return (
        <section className="roadmap-page">

            <div className="roadmap-hero">

                <span className="roadmap-label">
                    Product Roadmap
                </span>

                <h1>
                    Building the Future of Business Software
                </h1>

                <p>
                    Follow the evolution of the Magyne platform.
                    Explore released products, what's currently
                    Coming Soon, and what we're planning next.
                </p>

            </div>

            {roadmap.map((section) => (

                <section
                    key={section.id}
                    className="roadmap-section"
                >

                    <div className="roadmap-section-header">

                        <div
                            className="status-dot"
                            style={{
                                background: section.color
                            }}
                        />

                        <div>

                            <h2>{section.title}</h2>

                            <p>{section.description}</p>

                        </div>

                    </div>

                    <div className="roadmap-grid">

                        {section.products.map((product) => (

                            <RoadmapCard
                                key={product.name}
                                product={product}
                                color={section.color}
                            />

                        ))}

                    </div>

                </section>

            ))}

            <section className="feedback-section">

                <h2>Help Shape Magyne</h2>

                <p>
                    Have an idea that would improve your business?
                    We'd love to hear your suggestions as we continue
                    building the Magyne ecosystem.
                </p>

                <button type="button" onClick={() => navigate('/contact')}>
                    Contact Us
                </button>

            </section>

        </section>
    );
};

export default RoadmapPage;